import type { MangoQuerySelector } from 'rxdb'

import { Card } from '~/db/types'

export const buildListQuery = (
  userId: number,
  learnLanguageValue: string,
  sourceLanguageValue: string,
): MangoQuerySelector<Card> => ({
  learnLanguage: learnLanguageValue,
  sourceLanguage: sourceLanguageValue,
  userId,
})
